import * as RascunhoAnaliseActions from '../actions/rascunho-analise.actions';

export type RascunhoAnaliseActionsUnion = ReturnType<
  (typeof RascunhoAnaliseActions)[keyof typeof RascunhoAnaliseActions]
>;

export interface RascunhoAnaliseState {
  data: RascunhoAnaliseResponse | null;
  loading: boolean;
  error: string | null;
}

export const initialState = {
  data: null,
  loading: false,
  error: null,
};

export function reducer(
  state = initialState,
  action: RascunhoAnaliseActionsUnion
): RascunhoAnaliseState {
  switch (action.type) {
    case RascunhoAnaliseActions.loadRascunhosEmAnalise.type:
      return {
        ...state,
        loading: true,
      };

    case RascunhoAnaliseActions.loadRascunhosEmAnaliseSuccess.type:
      return {
        ...state,
        loading: false,
        data: action.data,
      };

    case RascunhoAnaliseActions.loadRascunhosEmAnaliseFailure.type:
      return {
        ...state,
        loading: false,
        error: 'Ocorreu um erro desconhecido',
      };

    default:
      return state;
  }
}

export const selectData = (state: RascunhoAnaliseState) => state.data;
